module.exports = __webpack_public_path__ + "img/1587907662.18a83b34.jpg";